const BASE_URL = "https://meet.wurknest.com:6950";

export default BASE_URL;
